export interface Strings {
  group?: {
    or?: string;
    and?: string;
    addRule?: string;
    addGroup?: string;
    delete?: string;
  };
  component?: {
    delete?: string;
  };
  form?: {
    selectYourValue?: string;
  };
  operators?: {
    LARGER?: string;
    SMALLER?: string;
    LARGER_EQUAL?: string;
    SMALLER_EQUAL?: string;
    EQUAL?: string;
    NOT_EQUAL?: string;
    ALL_IN?: string;
    ANY_IN?: string;
    NOT_IN?: string;
    BETWEEN?: string;
    NOT_BETWEEN?: string;
    EXISTS?: string;
    NOT_EXISTS?: string;
    CONTAINS?: string;
    LESS_THAN?: string;
    GREATER_THAN?: string;
    NOT_CONTAINS?: string;
  };
}

export const strings: Strings = {
  group: {
    or: 'Or',
    and: 'And',
    addRule: 'Add Rule',
    addGroup: 'Add Group',
    delete: 'Delete',
  },
  component: {
    delete: 'Delete',
  },
  form: {
    selectYourValue: 'Select your value',
  },
  operators: {
    LARGER: 'Larger',
    SMALLER: 'Smaller',
    LARGER_EQUAL: 'Larger or equal',
    SMALLER_EQUAL: 'Smaller or equal',
    EQUAL: 'Equal',
    NOT_EQUAL: 'Not equal',
    ALL_IN: 'All in',
    ANY_IN: 'Any in',
    NOT_IN: 'Not in',
    BETWEEN: 'Between',
    NOT_BETWEEN: 'Not between',
    EXISTS: 'Exists',
    NOT_EXISTS: 'Not exists',
    CONTAINS: 'Contains',
    NOT_CONTAINS: 'Not contains',
    LESS_THAN: 'Less than',
    GREATER_THAN: 'Greater than',
  },
};
